import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'decline-reason-modal',
  templateUrl: 'decline-reason-modal.component.html',
  styleUrls: ['decline-reason-modal.component.scss'],
  standalone: false
})
export class DeclineReasonModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
